import { POLCRCD_SAVE_LOADING, POLCRCD_SAVE_SUCCESS, POLCRCD_SAVE_FAIL, POLCRCD_LOAD_DATA, POLBANKDR_SAVE_LOADING, POLBANKDR_SAVE_SUCCESS, POLBANKDR_SAVE_FAIL, POLBANKDR_LOAD_DATA, POLCLSE_SAVE_LOADING, POLCLSE_SAVE_SUCCESS, POLCLSE_SAVE_FAIL, POLHDRSTATS_SAVE_LOADING, POLHDRSTATS_SAVE_SUCCESS, POLHDRSTATS_SAVE_FAIL } from '@/store/types'
export const header = {
  [POLCRCD_SAVE_LOADING](state) {
    state.policy.polCrCd.init = 0
    state.policy.polCrCd.saving = true
    state.policy.polCrCd.saveError.fieldMessages = []
    state.policy.polCrCd.saveError.messages = []
  },
  [POLCRCD_SAVE_SUCCESS](state) {
    state.policy.polCrCd.init = 1
    state.policy.polCrCd.saving = false
    state.policy.polCrCd.saveError.fieldMessages = []
    state.policy.polCrCd.saveError.messages = []
  },
  [POLCRCD_SAVE_FAIL](state, errMsgs) {
    state.policy.polCrCd.init = 2
    state.policy.polCrCd.saving = false
    state.policy.polCrCd.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polCrCd.saveError.messages = errMsgs.messages
  },
  [POLCRCD_LOAD_DATA](state, data) {
    if (data) {
      if (data.data !== null) {
        state.policy.polCrCd.polNo = data.data.id.polNo
        state.policy.polCrCd.renCnt = data.data.id.renCnt
        state.policy.polCrCd.endtCnt = data.data.id.endtCnt
        state.policy.polCrCd.effDate = data.data.id.effDate
        state.policy.polCrCd.crBank = data.data.crBank
        state.policy.polCrCd.crCdType = data.data.crCdType
        state.policy.polCrCd.crCdNo = data.data.crCdNo
        state.policy.polCrCd.cdSecurNo = data.data.cdSecurNo
        state.policy.polCrCd.cdHolderName = data.data.cdHolderName
        state.policy.polCrCd.expMth = data.data.expMth
        state.policy.polCrCd.expYr = data.data.expYr
        state.policy.polCrCd.entDate = data.data.entDate
        state.policy.polCrCd.entUsrId = data.data.entUsrId
        state.policy.polCrCd.modDate = data.data.modDate
        state.policy.polCrCd.modUsrId = data.data.modUsrId
        state.policy.polCrCd.token = data.data.token
        state.policy.polCrCd.createdDate = data.data.createdDate
        state.policy.polCrCd.createdBy = data.data.createdBy
        state.policy.polCrCd.modifiedDate = data.data.modifiedDate
        state.policy.polCrCd.modifiedBy = data.data.modifiedBy
        state.policy.polCrCd.revision = data.data.revision
      }
    }
  },
  [POLBANKDR_SAVE_LOADING](state) {
    state.policy.polBankDr.init = 0
    state.policy.polBankDr.saving = true
    state.policy.polBankDr.saveError.fieldMessages = []
    state.policy.polBankDr.saveError.messages = []
  },
  [POLBANKDR_SAVE_SUCCESS](state) {
    state.policy.polBankDr.init = 1
    state.policy.polBankDr.saving = false
    state.policy.polBankDr.saveError.fieldMessages = []
    state.policy.polBankDr.saveError.messages = []
  },
  [POLBANKDR_SAVE_FAIL](state, errMsgs) {
    state.policy.polBankDr.init = 2
    state.policy.polBankDr.saving = false
    state.policy.polBankDr.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polBankDr.saveError.messages = errMsgs.messages
  },
  [POLBANKDR_LOAD_DATA](state, data) {
    if (data) {
      if (data.data !== null) {
        state.policy.polBankDr.polNo = data.data.id.polNo
        state.policy.polBankDr.renCnt = data.data.id.renCnt
        state.policy.polBankDr.endtCnt = data.data.id.endtCnt
        state.policy.polBankDr.effDate = data.data.id.effDate
        state.policy.polBankDr.drBank = data.data.drBank
        state.policy.polBankDr.acctNo = data.data.acctNo
        state.policy.polBankDr.acctHolderName = data.data.acctHolderName
        state.policy.polBankDr.giNo = data.data.giNo
        state.policy.polBankDr.giStat = data.data.giStat
        state.policy.polBankDr.submitDate = data.data.submitDate
      }
    }
  },
  [POLCLSE_SAVE_LOADING](state) {
    state.policy.polClse.init = 0
    state.policy.polClse.saving = true
    state.policy.polClse.saveError.fieldMessages = []
    state.policy.polClse.saveError.messages = []
  },
  [POLCLSE_SAVE_SUCCESS](state) {
    state.policy.polClse.init = 1
    state.policy.polClse.saving = false
    state.policy.polClse.saveError.fieldMessages = []
    state.policy.polClse.saveError.messages = []
  },
  [POLCLSE_SAVE_FAIL](state, errMsgs) {
    state.policy.polClse.init = 2
    state.policy.polClse.saving = false
    state.policy.polClse.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polClse.saveError.messages = errMsgs.messages
  },
  [POLHDRSTATS_SAVE_LOADING](state) {
    state.policy.polHdrStats.init = 0
    state.policy.polHdrStats.saving = true
    state.policy.polHdrStats.saveError.fieldMessages = []
    state.policy.polHdrStats.saveError.messages = []
  },
  [POLHDRSTATS_SAVE_SUCCESS](state) {
    state.policy.polHdrStats.init = 1
    state.policy.polHdrStats.saving = false
    state.policy.polHdrStats.saveError.fieldMessages = []
    state.policy.polHdrStats.saveError.messages = []
  },
  [POLHDRSTATS_SAVE_FAIL](state, errMsgs) {
    state.policy.polHdrStats.init = 2
    state.policy.polHdrStats.saving = false
    state.policy.polHdrStats.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polHdrStats.saveError.messages = errMsgs.messages
  }
}
